
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"

export default defineComponent({
    name: "Service",
    components: { AclLayout },
    props: {
        service: {
            type: Object,
            default: () => null,
            required: false,
        },
        errors: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        form: {
            id: null,
            title: null,
            permission: null,
            url: null,
            iconUrl: null,
        },
    }),
    computed: {
        isEditMode(): boolean {
            return !!this.service
        },
    },
    beforeMount() {
        if (this.isEditMode) {
            for (const key in this.form) {
                if (this.service[key]) {
                    // @ts-ignore
                    this.form[key] = this.service[key]
                }
            }
        }
    },
    methods: {
        submit(): void {
            if (this.isEditMode) {
                this.$inertia.put("/admin/dynamic_services/" + this.service.id, this.form)
            } else {
                this.$inertia.post("/admin/dynamic_services", this.form)
            }
        },
    },
})
